"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import { BalancesContext } from "./context";
export const useBalances = () => {
  const $ = _c(10);
  const {
    balances,
    loading,
    refreshBalances
  } = useContext(BalancesContext);
  let t0;
  if ($[0] !== balances) {
    t0 = currencyId => balances.find(b => b.currency.chainIdentifier === currencyId.chainIdentifier && b.currency.contractAddress === currencyId.contractAddress);
    $[0] = balances;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getBalanceOfCurrency = t0;
  let t1;
  if ($[2] !== balances) {
    t1 = t2 => {
      const {
        chainIdentifier,
        symbol
      } = t2;
      return balances.find(b_0 => b_0.currency.chainIdentifier === chainIdentifier && b_0.currency.symbol === symbol);
    };
    $[2] = balances;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getBalanceOfCurrencyBySymbol = t1;
  let t2;
  if ($[4] !== balances || $[5] !== getBalanceOfCurrency || $[6] !== getBalanceOfCurrencyBySymbol || $[7] !== loading || $[8] !== refreshBalances) {
    t2 = {
      balances,
      loading,
      refreshBalances,
      getBalanceOfCurrency,
      getBalanceOfCurrencyBySymbol
    };
    $[4] = balances;
    $[5] = getBalanceOfCurrency;
    $[6] = getBalanceOfCurrencyBySymbol;
    $[7] = loading;
    $[8] = refreshBalances;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};